import { useContext, useEffect,useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, LinearProgress, Stack } from "@mui/material";
import { CasUserContext, useCasUserContext } from "../../services/casUserContext";
import { ProductoTerminadoDTO, getVoidProdcutoTerminadoDTO } from "../../interfaces/ProductoTerminadoDTO";
import { TblProductoProdTermin, setProductoTerminado } from "../../interfaces/TblProductoProdTermin";
import { ProductoAreaConocimientoDTO, setProductoAreaConocimientoDTO } from "../../interfaces/ProductoAreaConocimientoDTO";
import { ProductoLineaInvestigacionDTO, setProductoLineaInvestigacionDTO } from "../../interfaces/ProductoLineaInvestigacionDTO";
import { ProductoColaboradorDTO, setListProductoColaborador } from "../../interfaces/ColaboradorProdcutoDTO";
import { ProductoTerminadoObjOdDTO, setProductoTerminadoObjOdDTO } from "../../interfaces/ProductoTerminadoObjOdDTO";
import { TblDecInvMotivoProdTermin, setProductoMotivo } from "../../interfaces/TblDecInvMotivoProdTermin";
import ProductoService from "../../services/ProductoService";
import ProductoForm from "../../componentes/Productos/ProductoForm";
import { ProductoTerminSolicitanteDTO, setListProductoTerminSolicitante } from "../../interfaces/ProductoTerminSolicitanteDTO";
import UsuarioService from "../../services/UsuarioService";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import { ProductoObjEspecifico, setListProductoEspecifico } from "../../interfaces/ProductoObjEspecificoDTO";
import { setProductoInstitucionPais } from "../../interfaces/ProductoInstitucionPaisDTO";
import { setListProyectoRelacionado } from "../../interfaces/ProyectoRelacionado";
import { setProductoPostGrado } from "../../interfaces/ProductoPostGradoDTO";
import { setListProductoArchivo } from "../../interfaces/ProductoArchivo";
import { setListProductoResultado } from "../../interfaces/ProductoResultadoDTO";
import { ProductoFactorImpacto, SetListProductoFactorImpacto } from "../../interfaces/ProductoFactorImpacto";
import { ProductoAreaImplementacion, setAreaImplementacion } from "../../interfaces/ProductoAreaImplementacionDTO";
import { EmailProductoCreado, setEmailProductoCreado } from "../../interfaces/MailModel";
import EmailService from "../../services/EmailService";
import { GetProyectoEvntDTO } from "../../interfaces/ProyectosDTOS/EventoProyDTO";
import EventoService from "../../services/EventoService";

const productoService = new ProductoService();
const usuarioService = new UsuarioService();
const emailService = new EmailService();
const eventoService = new EventoService();

export const FormProductWithProyPage: React.FC<{}> = () =>{
    //Seccion variables
    let {idproyecto} = useParams();
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const token = casUserContext.token;
    const idpersona = casUserContext.userData.idpersona;
    const user = casUserContext.userData;
    const [ready,setReady] = useState(false);
    const [idCategoria,setIdCategoria] = useState(0); 
    const [datosFormulario,setDatosFormulario] = useState<ProductoTerminadoDTO>(()=> getVoidProdcutoTerminadoDTO());
    const[auth,setAuth] = useState(false);
    let history = useNavigate();
    //Seccion de carga
    useEffect(() => {
        const flag = usuarioService.authorized(user.roles);
        //console.log(user);
        setAuth(flag);
        if(flag){  
          fetchData();
        }
    },[]);
    useEffect(() => {
        const flag = usuarioService.authorized(user.roles);
        //console.log(user);
        setAuth(flag);
        if(flag){
          fetchData();
        }
    },[token]);
    //seccion Funciones
    const fetchData = async () =>{
        try{
             await productoService.GetProductoTerminadoWithProyecto(parseInt(idproyecto || '0'),user.nombreCompleto,token)
             .then((data) => {
                //console.log(data.data);
                setProducto(data)
             })               
             .catch((error) => console.error(error));                       
        }catch(error){
          console.error('Error:',error);
        }
    };
    function setProducto(data: any) {
        //console.log(data);
        setDatosFormulario({
            ...datosFormulario,
            producto: setProductoTerminado(data.data.producto) as TblProductoProdTermin,
            motivo: setProductoMotivo(data.data.motivo) as TblDecInvMotivoProdTermin,
            areaConocimiento: setProductoAreaConocimientoDTO(data.data.areaConocimiento) as ProductoAreaConocimientoDTO,
            areaImplementacion: setAreaImplementacion(data.data.areaImplementacion) as ProductoAreaImplementacion,
            lineaInvestigacion: setProductoLineaInvestigacionDTO(data.data.lineaInvestigacion) as ProductoLineaInvestigacionDTO,
            ods: setProductoTerminadoObjOdDTO(data.data.ods) as ProductoTerminadoObjOdDTO,
            colProducto: setListProductoColaborador(data.data.colProducto) as Array<ProductoColaboradorDTO>,
            solicitantes: setListProductoTerminSolicitante(data.data.solicitantes) as Array<ProductoTerminSolicitanteDTO>,
            institucion: setProductoInstitucionPais(data.data.institucion),
            archivosProd: setListProductoArchivo(data.data.archivosProd),
            proyectorel: setListProyectoRelacionado(data.data.proyectorel),
            postgrados: setProductoPostGrado(data.data.postgrados),
            objEspecificos: setListProductoEspecifico(data.data.objEspecificos) as Array<ProductoObjEspecifico>,
            factorImpacto: SetListProductoFactorImpacto(data.data.factorImpacto) as Array<ProductoFactorImpacto>,
            resultados: setListProductoResultado(data.data.resultados), 
            idpersona: idpersona,
            idCategoriaProducto: data.data.idCategoriaProducto as number,
        });
        setIdCategoria(data.idCategoriaProducto);
        setReady(true);
        //console.log(datosFormulario);
    }
    const goToNavigation = (site:string) =>{
        history(site)
    }
    const handleResponse = async (responseData: ProductoTerminadoDTO) => {
        // Manejar la respuesta aquí
        if(responseData.producto.iddecinvproyecto > 0){
            var evnt = GetProyectoEvntDTO(responseData.producto.iddecinvproyecto,user.idinv,responseData.producto.iddecinvtipoproductoesperado,"INGRESO DE",responseData.producto.titulo,"");
            const respE = await eventoService.GuardarEventoProductoIngresado(evnt,token);
        }
        var obt:EmailProductoCreado = setEmailProductoCreado("Ingreso de Producto",user.emailAddress,responseData);
        const resp = await emailService.MailProductoCreado(obt,token); 
        goToNavigation('/Producto/MisProductos');
    };   

    return(
        <Container sx={{mt:2, mb:4}}>
            <br />
            {auth ? 
            <>{ready ?
            <ProductoForm 
                productoterminado={datosFormulario} 
                defaultTipo={0} 
                defaultCategoria={idCategoria} 
                idProducto={'0'} 
                tiposAvalible={[]}
                categoriasAvalible={[]} 
                onResponse={handleResponse}
            />
            :
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                <LinearProgress color="secondary" />
            </Stack>}
          </>
          :
          <UnauthorizedPage />
          }
        </Container>
    );
}

